import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Area from '../../../../../common/chart/chartContainer/Area'
import { Legend } from '../../../../../common/chart/legend'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../helpers/common'
import {
  convertData,
  formatVal,
  valToPercent,
} from '../../../../../helpers/value'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import { changeChecked, selectChecked } from '../../store/slice'
import { RATIO_CODE, TREND_DATA } from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const findMax = (key, data) =>
  data.reduce((max, item) => {
    if (item[key] > max) {
      return item[key]
    }
    return max
  }, 0)

const Trend = ({ id, check, isDynamicReport, isDownloadComponent }) => {
  const chartId = useRef(getUnique())
  const { getExchangeRate, multiplier } = useFormatCurrency(
    SCREEN.FINANCIAL_ANALYSIS,
  )

  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
    [
      RATIO_CODE.TOTAL_AVG,
      RATIO_CODE.OWNER_EQUITY_AVG,
      RATIO_CODE.TOTAL_RATIO,
      RATIO_CODE.OWNER_EQUITY,
    ],
  )

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const checkboxs = TREND_DATA.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const areas = checkboxs
    .filter((item) => checked.includes(item.value) && !item.disableFill)
    .sort((item1, item2) => {
      return (
        findMax(item2.value, dataConvert) - findMax(item1.value, dataConvert)
      )
    })

  const lines = checkboxs
    .filter((item) => checked.includes(item.value) && item.disableFill)
    .sort((item1, item2) => {
      return (
        findMax(item2.value, dataConvert) - findMax(item1.value, dataConvert)
      )
    })

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <div
      style={{
        height: isDownloadComponent
          ? '100%'
          : getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className="dFlex"
    >
      <div className="flexColumn w60 h100">
        <ChartContainer
          chartId={chartId.current}
          data={dataConvert}
          margin={{
            top: 10,
            bottom: 0,
            left: isDynamicReport ? 16 : 0,
            right: 16,
          }}
          width="100%"
          height="100%"
          xAxis={[
            {
              dataKey: 'year',
              type: 'category',
            },
          ]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: [...areas, ...lines].map((item) => item.value),
              isBarChart: true,
              tickFormatter: (value) => formatVal(value, locale) + '%',
            },
          ]}
          tooltip={{
            schema: {
              content: [...areas, ...lines].map((item) => ({
                dataKey: item.value,
                label: item.title,
                formatValue: (value) => valToPercent(value, locale, true),
              })),
            },
          }}
        >
          {[...areas, ...lines].map((item) => {
            return (
              <Area
                key={item.value}
                yAxisId="left"
                dataKey={item.value}
                fill={item.color}
                stroke={item.color}
                strokeWidth={2}
                fillOpacity={item.disableFill ? 0 : 1}
                dot={{
                  stroke: item.dotColor,
                  fill: item.dotColor,
                  fillOpacity: 1,
                  strokeWidth: 1.5,
                }}
              />
            )
          })}
        </ChartContainer>
      </div>
      <div className="h100 w40 pl2 dFlex alignItemsCenter justifyContentCenter">
        <Legend
          chartId={chartId.current}
          items={checkboxs.map((item) => ({
            title: item.title,
            value: item.value,
            dataKey: item.value,
            color: item.color,
            isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
            listCheckBox: checked,
            setListCheckBox: setChecked,
            isI18n: false,
            isDynamicReport: isDynamicReport || isDownloadComponent,
          }))}
          className="flexColumn"
          style={{ gap: 3 }}
        />
      </div>
    </div>
  )
}

export default Trend
